import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Card, Col, Image, Row } from 'react-bootstrap';
import Footer from '../Shared/Footer/Footer';
import Header from '../Shared/Header/Header';
import './Skills.css';
import { useApp } from '../../contexts/AppContext';

const Skills = () => {
   const { isInitialLoad, setIsInitialLoad } = useApp();

   useEffect(() => {
     if (isInitialLoad) return;
     setIsInitialLoad(true);
   }, [isInitialLoad, setIsInitialLoad]);
  return (
    <>
      <Header></Header>
      <div className='container-fluid mt-2 mb-5 pt-5' id='features'>
        <motion.h1
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 2 }}
          className='fw-bolder mb-3 text-primary'
        >
          My Skills
        </motion.h1>

        <motion.h4
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 2 }}
          className='text-center mb-5 text-secondary'
        >
          Diverse Skills of Different Tools & Technologies
        </motion.h4>
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 2 }}
        >
          {' '}
          <Row xs={1} md={6} className='g-4 d-flex align-items-center mt-4'>
            <Col>
              <Card className='text-center  shadow-lg p-1 mb-5 bg-body rounded card'>
                <span className='icon-color pt-2'>
                  <Image
                    src='https://img.icons8.com/color/48/000000/html-5--v1.png'
                    fluid
                  />
                </span>
                <Card.Body>
                  <Card.Title className='fw-bold'> HTML5</Card.Title>
                </Card.Body>
              </Card>
            </Col>

            <Col>
              <Card className='text-center  shadow-lg p-1 mb-5 bg-body rounded card'>
                <span className='icon-color pt-2'>
                  <Image
                    src='https://img.icons8.com/color/48/000000/css3.png'
                    fluid
                  />
                </span>
                <Card.Body>
                  <Card.Title className='fw-bold'> CSS3</Card.Title>
                </Card.Body>
              </Card>
            </Col>

            <Col>
              <Card className='text-center  shadow-lg p-1 mb-5 bg-body rounded card'>
                <span className='icon-color pt-2'>
                  <Image
                    src='https://img.icons8.com/color/48/000000/javascript--v1.png'
                    fluid
                  />
                </span>
                <Card.Body>
                  <Card.Title className='fw-bold'> JavaScript</Card.Title>
                </Card.Body>
              </Card>
            </Col>
            <Col>
              <Card className='text-center  shadow-lg p-1 mb-5 bg-body rounded card'>
                <span className='icon-color pt-2'>
                  <Image
                    src='https://img.icons8.com/officel/48/000000/react.png'
                    fluid
                  />
                </span>
                <Card.Body>
                  <Card.Title className='fw-bold'> React JS</Card.Title>
                </Card.Body>
              </Card>
            </Col>
            <Col>
              <Card className='text-center  shadow-lg p-1 mb-5 bg-body rounded card'>
                <span className='icon-color pt-2'>
                  <Image
                    src='https://img.icons8.com/color/48/000000/nextjs.png'
                    fluid
                  />
                </span>
                <Card.Body>
                  <Card.Title className='fw-bold'> Next JS</Card.Title>
                </Card.Body>
              </Card>
            </Col>
            <Col>
              <Card className='text-center  shadow-lg p-1 mb-5 bg-body rounded card'>
                <span className='icon-color pt-2'>
                  <Image
                    src='https://img.icons8.com/color/48/000000/redux.png'
                    fluid
                  />
                </span>
                <Card.Body>
                  <Card.Title className='fw-bold'> Redux</Card.Title>
                </Card.Body>
              </Card>
            </Col>
            <Col>
              <Card className='text-center  shadow-lg p-1 mb-5 bg-body rounded card'>
                <span className='icon-color pt-2'>
                  <Image
                    src='https://img.icons8.com/color/48/000000/bootstrap.png'
                    fluid
                  />
                </span>
                <Card.Body>
                  <Card.Title className='fw-bold'> Bootstrap 5</Card.Title>
                </Card.Body>
              </Card>
            </Col>
            <Col>
              <Card className='text-center  shadow-lg p-1 mb-5 bg-body rounded card'>
                <span className='icon-color pt-2'>
                  <Image
                    src='https://img.icons8.com/color/48/000000/tailwindcss.png'
                    fluid
                  />
                </span>
                <Card.Body>
                  <Card.Title className='fw-bold'>Tailwind CSS</Card.Title>
                </Card.Body>
              </Card>
            </Col>

            <Col>
              <Card className='text-center  shadow-lg p-1 mb-5 bg-body rounded card'>
                <span className='icon-color pt-2'>
                  <Image
                    src='https://img.icons8.com/color/48/000000/firebase.png'
                    fluid
                  />
                </span>
                <Card.Body>
                  <Card.Title className='fw-bold'>
                    {' '}
                    Firebase Authentication
                  </Card.Title>
                </Card.Body>
              </Card>
            </Col>

            <Col>
              <Card className='text-center  shadow-lg p-1 mb-5 bg-body rounded card'>
                <span className='icon-color pt-2'>
                  <Image
                    src='https://img.icons8.com/color/48/000000/java-web-token.png'
                    fluid
                  />
                </span>
                <Card.Body>
                  <Card.Title className='fw-bold'> JSON Web Token</Card.Title>
                </Card.Body>
              </Card>
            </Col>

            <Col>
              <Card className='text-center  shadow-lg p-1 mb-5 bg-body rounded card'>
                <span className='icon-color pt-2'>
                  <Image
                    src='https://img.icons8.com/color/48/000000/stripe.png'
                    fluid
                  />
                </span>
                <Card.Body>
                  <Card.Title className='fw-bold'>
                    {' '}
                    Stripe Integration
                  </Card.Title>
                </Card.Body>
              </Card>
            </Col>

            <Col>
              <Card className='text-center  shadow-lg p-1 mb-5 bg-body rounded card'>
                <span className='icon-color pt-2'>
                  <Image
                    src='https://img.icons8.com/color/48/000000/html-5--v1.png'
                    fluid
                  />
                </span>
                <Card.Body>
                  <Card.Title className='fw-bold'> Node JS</Card.Title>
                </Card.Body>
              </Card>
            </Col>

            <Col>
              <Card className='text-center  shadow-lg p-1 mb-5 bg-body rounded card'>
                <span className='icon-color pt-2'>
                  <Image
                    src='https://www.vectorlogo.zone/logos/expressjs/expressjs-ar21.svg'
                    fluid
                  />
                </span>
                <Card.Body>
                  <Card.Title className='fw-bold'> Express JS</Card.Title>
                </Card.Body>
              </Card>
            </Col>
            <Col>
              <Card className='text-center  shadow-lg p-1 mb-5 bg-body rounded card'>
                <span className='icon-color pt-2'>
                  <Image
                    src='https://img.icons8.com/color/48/000000/mongodb.png'
                    fluid
                  />
                </span>
                <Card.Body>
                  <Card.Title className='fw-bold'> MongoDB Atlas</Card.Title>
                </Card.Body>
              </Card>
            </Col>

            <Col>
              <Card className='text-center  shadow-lg p-1 mb-5 bg-body rounded card'>
                <span className='icon-color pt-2'>
                  <Image
                    src='https://img.icons8.com/color/48/000000/npm.png'
                    fluid
                  />
                </span>
                <Card.Body>
                  <Card.Title className='fw-bold'> NPM</Card.Title>
                </Card.Body>
              </Card>
            </Col>

            <Col>
              <Card className='text-center  shadow-lg p-1 mb-5 bg-body rounded card'>
                <span className='icon-color pt-2'>
                  <Image
                    src='https://img.icons8.com/external-tal-revivo-shadow-tal-revivo/48/000000/external-yarn-fast-reliable-and-secure-dependency-management-web-portal-logo-shadow-tal-revivo.png'
                    fluid
                  />
                </span>
                <Card.Body>
                  <Card.Title className='fw-bold'> Yarn</Card.Title>
                </Card.Body>
              </Card>
            </Col>

            <Col>
              <Card className='text-center  shadow-lg p-1 mb-5 bg-body rounded card'>
                <span className='icon-color pt-2'>
                  <Image
                    src='https://img.icons8.com/ios-glyphs/48/000000/github.png'
                    fluid
                  />
                </span>
                <Card.Body>
                  <Card.Title className='fw-bold'> Git</Card.Title>
                </Card.Body>
              </Card>
            </Col>

            <Col>
              <Card className='text-center  shadow-lg p-1 mb-5 bg-body rounded card'>
                <span className='icon-color pt-2'>
                  <Image
                    src='https://img.icons8.com/external-tal-revivo-color-tal-revivo/48/000000/external-netlify-a-cloud-computing-company-that-offers-hosting-and-serverless-backend-services-for-static-websites-logo-color-tal-revivo.png'
                    fluid
                  />
                </span>
                <Card.Body>
                  <Card.Title className='fw-bold'> Netlify</Card.Title>
                </Card.Body>
              </Card>
            </Col>

            <Col>
              <Card className='text-center  shadow-lg p-1 mb-5 bg-body rounded card'>
                <span className='icon-color pt-2'>
                  <Image
                    src='https://img.icons8.com/color/48/000000/heroku.png'
                    fluid
                  />
                </span>
                <Card.Body>
                  <Card.Title className='fw-bold'> Heroku</Card.Title>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </motion.div>
      </div>
      <Footer></Footer>
    </>
  );
};

export default Skills;
